// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SwaF","comment":"styles_comment__2G-nb"};